import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.object.assign";
import _toConsumableArray from "/Users/jquense/src/react-overlays/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import normalizeTokens from './normalizeTokens';
import themeToDict from './themeToDict';

function useThemeDict(theme, language) {
  return useMemo(function () {
    return theme && themeToDict(theme, language);
  }, [language, theme]);
}

export default function useHighlight(_ref) {
  var theme = _ref.theme,
      language = _ref.language,
      code = _ref.code,
      Prism = _ref.Prism;
  var themeDict = useThemeDict(theme, language);

  var getStyleForToken = function getStyleForToken(_ref2) {
    var types = _ref2.types,
        empty = _ref2.empty;
    var typesSize = types.length;

    if (themeDict === undefined) {
      return undefined;
    }

    if (typesSize === 1 && types[0] === 'plain') {
      return empty ? {
        display: 'inline-block'
      } : undefined;
    }

    if (typesSize === 1 && !empty) {
      return themeDict[types[0]];
    }

    var baseStyle = empty ? {
      display: 'inline-block'
    } : {};
    var typeStyles = types.map(function (type) {
      return themeDict[type];
    });
    return Object.assign.apply(Object, [baseStyle].concat(_toConsumableArray(typeStyles)));
  };

  var getLineProps = function getLineProps(_ref3) {
    var key = _ref3.key,
        className = _ref3.className,
        style = _ref3.style,
        _ = _ref3.line,
        rest = _objectWithoutProperties(_ref3, ["key", "className", "style", "line"]);

    var output = _objectSpread({}, rest, {
      className: 'token-line'
    });

    if (themeDict !== undefined) {
      output.style = themeDict.plain;
    }

    if (style !== undefined) {
      output.style = output.style !== undefined ? _objectSpread({}, output.style, {}, style) : style;
    }

    if (key !== undefined) output.key = key;
    if (className) output.className += " ".concat(className);
    return output;
  };

  var getTokenProps = function getTokenProps(_ref4) {
    var key = _ref4.key,
        className = _ref4.className,
        style = _ref4.style,
        token = _ref4.token,
        rest = _objectWithoutProperties(_ref4, ["key", "className", "style", "token"]);

    var output = _objectSpread({}, rest, {
      className: "token ".concat(token.types.join(' ')),
      children: token.content,
      style: getStyleForToken(token)
    });

    if (style !== undefined) {
      output.style = output.style !== undefined ? _objectSpread({}, output.style, {}, style) : style;
    }

    if (key !== undefined) output.key = key;
    if (className) output.className += " ".concat(className);
    return output;
  };

  var tokens = useMemo(function () {
    var grammar = Prism.languages[language];
    var mixedTokens = grammar !== undefined ? Prism.tokenizeWithHooks(code, grammar, language) : [code];
    return normalizeTokens(mixedTokens);
  }, [Prism, code, language]);
  return {
    tokens: tokens,
    getLineProps: getLineProps,
    getTokenProps: getTokenProps,
    props: {
      className: "prism-code language-".concat(language),
      style: themeDict !== undefined ? themeDict.plan : {}
    }
  };
}